import React from 'react';
import { Box } from '@mui/material';

interface DonutProps {
    value: number;
    total: number;
    label: string;
    size?: number;
}

export default function Donut({ value, total, label, size = 160 }: DonutProps) {
    const pct = total > 0 ? Math.round((value / total) * 100) : 0;
    const stroke = Math.max(10, Math.round(size * 0.1));
    const r = (size - stroke) / 2;
    const c = 2 * Math.PI * r;
    const dash = (pct / 100) * c;

    return (
        <Box sx={{
            width: size,
            height: size,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative'
        }}>
            <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
                <g transform={`translate(${size / 2}, ${size / 2}) rotate(-90)`}>
                    <circle r={r} cx={0} cy={0} fill="none" stroke="#eef3fb" strokeWidth={stroke} />
                    <circle
                        r={r}
                        cx={0}
                        cy={0}
                        fill="none"
                        stroke="url(#gradient)"
                        strokeWidth={stroke}
                        strokeLinecap="round"
                        strokeDasharray={`${dash} ${c - dash}`}
                        style={{ transition: 'stroke-dasharray 400ms ease' }}
                    />
                </g>
                <defs>
                    <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="0%">
                        <stop offset="0%" stopColor="#667eea" />
                        <stop offset="100%" stopColor="#764ba2" />
                    </linearGradient>
                </defs>
                <text
                    x={size / 2}
                    y={size / 2}
                    textAnchor="middle"
                    dominantBaseline="central"
                    fontSize={Math.round(size * 0.24)}
                    fontWeight={700}
                    fill="#1e293b"
                >
                    {pct}%
                </text>
                <text
                    x={size / 2}
                    y={Math.round(size / 2 + size * 0.28)}
                    textAnchor="middle"
                    fontSize={Math.round(size * 0.11)}
                    fill="#64748b"
                    fontWeight={500}
                >
                    {label}
                </text>
            </svg>
        </Box>
    );
}
